import styled from 'styled-components';
import { mediaMaxWidth } from 'common/styles/breakpoints';
import { BRAND_LIBRARY_DARK_TEXT_COLOR, BRAND_LIBRARY_HEADLINE_TEXT } from 'common/constants/brandLibrary';

import Headline from '../../Headline';

const GenericHeadline = styled(Headline)`
    padding: 0;

    ${mediaMaxWidth.medium`
        padding: 0;
    `}
`;

GenericHeadline.splash = {
    ...Headline.splash,
    defaultProps: {
        ...Headline.splash.defaultProps,
        styles: {
            ...Headline.splash.defaultProps.styles,
            fontSize: 24,
            fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
            fontFamily: BRAND_LIBRARY_HEADLINE_TEXT,
        },
        meta: {
            ...Headline.splash.defaultProps.meta,
            content: 'Add your headline content here',
            visible: true,
        },
    },
};

export default GenericHeadline;
